import { useState, useEffect} from 'react'
import Introduction from './Introduction';
import FinalPage from './FinalPage';
import {FormInfo,TriageScore,TriageForms} from './forms/FormInfo';
import { Copyright,Text,Background} from '../styles/style.js';
import Form from './forms/Form'
import WriteDB from '../API/WriteDB.js';
import {useDispatch,useSelector} from 'react-redux'
import { setName} from '../redux/UserSlice.js';
import { setExamLink, setExamType,setFormList,setCompletedForms,setTriageScore} from '../redux/ExamSlice.js';
import ReadDB from '../API/ReadDB.js'
import Navigation from './Navigation';

const readDB = new ReadDB();
const writeDB = new WriteDB();
export default function LinkExam(props){
    const [currentForm,setCurrentForm] = useState('')
    const [showIntroduction,setShowIntroduction] = useState(true)
    const triageScore = useSelector((state) => state.exam.triageScore)
    const examType = useSelector((state) => state.exam.examType);
    const completedForms = useSelector((state) => state.exam.completedForms);
    const formList = useSelector((state) => state.exam.formList);
    const dispatch = useDispatch();

    useEffect(()=>{
        async function readLink(){
            if(window.location.pathname === '/'){
                props.loading(false)
                setShowIntroduction(false)
                setCurrentForm(FormInfo.Introduction.name)
            }else{
                var response =  await readDB.readLink(window.location.pathname)
                if(response.Item === undefined){
                    props.loading(false)
                    setShowIntroduction(false)
                    setCurrentForm(FormInfo.Introduction.name)
                }else{
                    props.loading(false)
                    setShowIntroduction(true)
                    dispatch(setName(response.Item.name))
                    dispatch(setExamLink(window.location.pathname))
                    dispatch(setExamType(response.Item.type))
                    if(response.Item.completedForms !== undefined){
                        dispatch(setCompletedForms(response.Item.completedForms))
                    }

                    if(response.Item.tempTriage !== undefined){
                        dispatch(setTriageScore(response.Item.tempTriage))
                    }

                    setCurrentForm(FormInfo.Introduction.name)
                    dispatch(setFormList(response.Item.formList))
                    
                }
            }
        }
        
        if(props.type === 'link'){
            readLink();
        }else{
            for(let i = 0;i < formList.length;i++){
                if(!completedForms.includes(formList[i])){
                    setCurrentForm(formList[i])
                    break;
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])


    /**
     * Adds to the total triage number based on the score the user input for certain forms
     * @param {String} form the name of the form
     * @param {int} score the score the user received for the form
     */
     function addTriageNumber(form,score){
        var triageObject;
        var tempScore = triageScore;
        switch(form){
            case FormInfo.PHQ9.name:
                triageObject = TriageScore.PHQ9;
                break;
            case FormInfo.GAD.name:
                triageObject = TriageScore.GAD;
                break;
            case FormInfo.MDQ.name:
                triageObject = TriageScore.MDQ;
                break;
            case FormInfo.BPD.name:
                triageObject = TriageScore.BPD;
                break;
            case FormInfo.AQ10.name:
                triageObject = TriageScore.AQ10;
                break;
            case FormInfo.ASRS5.name:
                triageObject = TriageScore.ASRS5;
                break;
            case FormInfo.AUDIT.name:
                triageObject = TriageScore.AUDIT;
                break;
            case FormInfo.DAST.name:
                triageObject = TriageScore.DAST;
                break;
            default:
                
        }

        if(form === FormInfo.WHO5.name){
            if(score <= TriageScore.WHO5.high){
                tempScore += TriageScore.Total.high
            }else if(score <= TriageScore.WHO5.medium){
                tempScore += TriageScore.Total.medium
            }else if(score <= TriageScore.WHO5.low){
                tempScore += TriageScore.Total.low
            }
        }else{
            if(score >= triageObject.high){
                tempScore += TriageScore.Total.high;
            }else if(score >= triageObject.medium){
                tempScore += TriageScore.Total.medium
            }else if(score >= triageObject.low){
                tempScore += TriageScore.Total.low
            }
        }

        dispatch(setTriageScore(tempScore))
        writeDB.writeTempTriage();
    }

    function checkTriage(){
        return TriageForms.every(i => formList.includes(i));
    }

    /**
     * Receives the messages from the form components and determines the next form to show the user.
     * @param {Object} object the object that stores the name and message of the form
     */
     const receiveMessage = async(object) =>{
        var formName = Object.keys(object)[0];
        var formValue = Object.values(object)[0];
        if(TriageForms.includes(formName) && checkTriage()){
            addTriageNumber(formName,formValue);
        }

        dispatch(setCompletedForms([...completedForms,formName]))
        if(examType === 'Full Exam' || examType === 'Initial'){
            if(formName === FormInfo.AQ10.name && formValue >= 4){
                dispatch(setFormList([...formList,FormInfo.AQ50.name]))
                await writeDB.addForm(FormInfo.AQ50.name)
            }else if(formName === FormInfo.MDQ.name && formValue >= 7){
                dispatch(setFormList([...formList,FormInfo.ASRM.name]))
                await writeDB.addForm(FormInfo.ASRM.name)
            }else if(formName === FormInfo.ASRS5.name && formValue >= 10){
                dispatch(setFormList([...formList,FormInfo.ASRS.name]))
                await writeDB.addForm(FormInfo.ASRS.name)
            }
        }

        if(currentForm === FormInfo.Introduction.name){
            if(completedForms === undefined){
                setCurrentForm(formList[0])
            }else{
                for(let i = 0;i < formList.length;i++){
                    if(!completedForms.includes(formList[i])){
                        setCurrentForm(formList[i])
                        break;
                    }
                }
            }
        }else if(formList.indexOf(formName) + 1 !== formList.length){
            setCurrentForm(formList[formList.indexOf(formName) + 1])
        }else{
            if(checkTriage()){
                var response = await writeDB.writeTriage();
                if(response !== 'Write Triage Error' && props.type === 'link'){
                    setCurrentForm(FormInfo.FinalPage.name)
                }else if(response !== 'Write Triage Error'){
                    props.examDone()
                }
            }else if(props.type === 'link'){
                setCurrentForm(FormInfo.FinalPage.name)
            }else{
                props.examDone()
            }
        }
    }

    return(
        <>
            {currentForm === FormInfo.Introduction.name && 
                <>
                    <Introduction 
                        showIntroduction={showIntroduction} 
                        type={examType} 
                        message={receiveMessage}>
                    </Introduction>
                    <Copyright>
                        © {new Date().getFullYear()} BHTI
                    </Copyright>
                </>
            }
            
            {currentForm !== FormInfo.Introduction.name && currentForm !== FormInfo.FinalPage.name &&
                <Background>
                    {props.type === 'link' &&
                        <Navigation showNavigation={false} theme={props.theme} changeTheme={props.changeTheme}></Navigation>
                    }
                    <Text>
                        Form: {formList.indexOf(currentForm) + 1}/{formList.length}
                    </Text>

                    {currentForm !== FormInfo.Prime.name && currentForm !== '' &&
                        <Form key={currentForm} formName={currentForm} message={receiveMessage}></Form>
                    }
                
                    {currentForm === FormInfo.Prime.name && 
                        <Form 
                            formName={FormInfo.Prime.name}
                            fullExam={examType === 'Initial' || examType === 'Full Exam'} 
                            message={receiveMessage}>
                        </Form>
                    }
                </Background>
            }

            {currentForm === FormInfo.FinalPage.name &&
                <>
                    <FinalPage message={receiveMessage}></FinalPage>
                    <Copyright>
                        © {new Date().getFullYear()} BHTI
                    </Copyright>
                </>
            }
        </>
    )
}